import { atom } from 'jotai';

export const virtualAssistantShowAssistantAtom = atom<boolean>(false);
